import { BORDER_RADIUS } from '@app/style/constants';
import styled from 'styled-components';

/**
 * Slick positions its arrows outside the slider (left: -25px), which the wrapper's
 * overflow: hidden would clip — so they are pulled inside and given contrast to stay
 * legible over a photographic banner.
 *
 * AntD already draws the chevron itself on ::after (white, rotated 45deg) — it just
 * ships at opacity .4, which reads as an empty circle. Don't add another glyph here.
 * Its inset is tuned for AntD's default arrow size, so it needs re-centring inside
 * the larger hit area below.
 */
export const StyledBannerWrapper = styled.div`
	position: relative;
	overflow: hidden;
	border-radius: ${BORDER_RADIUS};
	background-color: transparent;

	.slick-prev,
	.slick-next {
		z-index: 2;
		width: 32px;
		height: 32px;
		border-radius: 50%;
		opacity: 1;
		background-color: rgba(0, 0, 0, 0.35);
		transition: background-color 0.3s;

		&:hover,
		&:focus {
			background-color: rgba(0, 0, 0, 0.55);
		}

		&::after {
			inset: 0;
			width: 8px;
			height: 8px;
			margin: auto;
		}
	}

	.slick-prev {
		left: 16px;
	}

	.slick-next {
		right: 16px;
	}
`;
